import '../../section-specific/sponsors/sponsors';
import MainVue from '../../main-vue';
import {
    ApiUrls
} from '../../helper-functions';

import '../../filters/filters.number-format';
import Modal from '../../components/components.model.vue';

new MainVue({
    el: '#app',
    components: {
        'v-ratings': () => import ('../../components/components.rating.vue'),
        Modal
    },
    data: function () {
        return {
            name: "Sponsors",
            mapUrl: '',
            company: {
                address: null,
                reviewsCount: null,
                h1bVisaCount: null,
                gcVisaCount: null,
                companyId: null,
                companyName: null,
                averageCount: 0,
                zipCode: null,
                claimStatus: '',
                claimerUserName: null
            },
            zipCode: window.immiObj?.zipCodeUrl,
            showModal: false,
            modal: {
                title: '',
                content: ''
            },
            loaded: false,
            noAddress: false
        }
    },
    created () {
        if (window.immiObj && window.immiObj.employerName && !window.immiObj.ismap) {
            this.getEmployerCount(window.immiObj.employerName);
        } else if (window.immiObj && window.immiObj.zipCodeDetail && window.immiObj.zipCodeDetail.city) {
            const address = `${window.immiObj.zipCodeDetail.city}, ${window.immiObj.zipCodeDetail.state} ${window.immiObj.zipCodeDetail.zipCode}`;
            this.getMapDetails(address.toLowerCase());
        } else if (window.immiObj.ismap && window.immiObj.address) {
            const address = window.immiObj.address;
            const pathName = window.location.pathname.split('/').filter(item=>item)
            this.company.zipCode = pathName[pathName.length - 1];            
            this.getMapDetails(address.toLowerCase());
        }
    },
    methods: {
        getEmployerCount (employerName) {
            employerName = employerName.replace(/\s/g, '_');
            this.noAddress = true;
            this.$http.get(ApiUrls.sponsors.employerCounts + '?employerName=' + encodeURIComponent(employerName), {
                employerName: employerName
            }).then(res=>{
                if (res.body && res.body.companyId) {
                    this.company = {...res.body};
                    this.company.averageCount = +this.company.averageCount || 0;
                    if (this.company.address) {                        
                        this.getMapDetails(this.company.address);
                    } else {
                        this.noAddress = false;
                    }
                }
                this.loaded = true;
            })
        },
        getMapDetails (address) {
            address = address.replace(/\s/g,'+').toLowerCase();
            this.noAddress = true;
            this.$http.get('https://nominatim.openstreetmap.org/search?q='+address+'&format=json&polygon=1&addressdetails=1').then(res =>{
                const responseBody = res.body;
                if (responseBody && Array.isArray(responseBody) && responseBody.length) {
                    const latlong = responseBody[0].boundingbox || [];
                    if (latlong && latlong.length === 4) {
                        this.mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${latlong[2]}%2C${latlong[0]}%2C${latlong[3]}%2C${latlong[1]}&amp;layer=mapnik`;
                        this.noAddress = false;
                    }
                }
            })
        },
        openModal (key) {
            const $content = document.querySelector('#tooltip-'+key);
            if ($content) {
                this.modal.title = $content.querySelector('header').innerText;
                this.modal.content = $content.querySelector('.o-Tooltip__body').innerHTML;
                this.showModal = true;
            }
        }
    }
});